<script setup>
import { onMounted, watch, ref } from 'vue';
import { useProjeto } from '@/modules/projeto/composables/useProjeto';

const { metas, carregarMetas } = useProjeto();

const props = defineProps({
    projetoId: String,
    erro: {
        type: String,
        default: null
    },
    modelValue: {
        type: Number,
        default: null
    },
    disabled: {
        type: Boolean,
        default: false
    },
})

const emit = defineEmits(['update:modelValue', 'change']);

const metaSelecionada = ref(null);

// Watch para sincronizar modelValue com a meta selecionada
watch(() => props.modelValue, async (newValue) => {
    if (newValue) {
        await carregarMetas(props.projetoId);

        const meta = metas.value.find(m => m.id === newValue);
        if (meta && metaSelecionada.value?.id !== newValue) {
            metaSelecionada.value = meta;
        }
    } else if (metaSelecionada.value !== null) {
        metaSelecionada.value = null;
    }
}, { immediate: true });

// Watch para carregar metas quando projetoId mudar
watch(
    () => props.projetoId,
    async (newProjetoId) => {
        if (newProjetoId) {
            await carregarMetas(newProjetoId);

            // Sincronizar com modelValue após carregar metas
            if (props.modelValue) {
                metaSelecionada.value = metas.value.find(meta => meta.id === props.modelValue) || null;
            }
        } else {
            metaSelecionada.value = null;
        }
    }
);

// Watch para emitir mudanças quando usuário seleciona uma meta
watch(metaSelecionada, (newMeta) => {
    const newValue = newMeta?.id || null;
    if (newValue !== props.modelValue) {
        emit('update:modelValue', newValue);
        emit('change', newValue);
    }
});

onMounted(async () => {
    // Aguardar carregamento inicial das metas
    if (props.projetoId) {
        await carregarMetas(props.projetoId);
    }
});
</script>

<template>
    <div class="field mb-2 col-12">
        <SmallTitle titulo="Meta" :obrigatorio="true" />
        <Dropdown :options="metas" v-model="metaSelecionada" optionLabel="descricao"
            emptyFilterMessage="Nenhuma meta encontrada" :class="{ 'p-invalid': props.erro }"
            placeholder="Selecione a meta" :showClear="true" :disabled="props.disabled">
        </Dropdown>
        <SmallError v-if="props.erro" :error="props.erro" />
    </div>
</template>